import { render } from "./AuthorizationCheckResultModal.vue?vue&type=template&id=353fafec&scoped=true"
import script from "./AuthorizationCheckResultModal.vue?vue&type=script&lang=js"
export * from "./AuthorizationCheckResultModal.vue?vue&type=script&lang=js"

import "./AuthorizationCheckResultModal.vue?vue&type=style&index=0&id=353fafec&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-353fafec"],['__file',"src/containers/components/messagePopup/AuthorizationCheckResultModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "353fafec"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('353fafec', __exports__)) {
    api.reload('353fafec', __exports__)
  }
  
  module.hot.accept("./AuthorizationCheckResultModal.vue?vue&type=template&id=353fafec&scoped=true", () => {
    api.rerender('353fafec', render)
  })

}


export default __exports__